export default (itemId: string) => `quiz-timer-${itemId}`;
